import React, { useEffect, useState, useRef } from "react";

const ProductSalePointTable = () => {
    const [sp_plans, setSpPlan] = useState([]);
    const [loading, setLoading] = useState(true);
    const didFetch = useRef(false); // 👈 add this

    useEffect(() => {
        if (didFetch.current) return; // 👈 prevent 2nd call
        didFetch.current = true;

        const fetchUsers = async () => {
            try {
                const response = await fetch("https://admin.swatee.in/api/get-products");
                const data = await response.json();
                setSpPlan(data.data);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching users:", error);
                setLoading(false);
            }
        };

        fetchUsers();
    }, []);

    if (loading) return <p>Loading...</p>;

    return (
        <div>
            <table class="min-w-full border-2 text-center sm:table-auto">
                <thead class="bg-primary border-b-2 border-secondary">
                    <tr>
                        <th className="border-2 p-3 text-lg font-semibold tracking-wide">
                            SNo.
                        </th>
                        <th class="border-2 p-3 text-lg font-semibold tracking-wide">
                            Product Name
                        </th>
                        <th class="border-2 p-3 text-lg font-semibold tracking-wide">
                            SP
                        </th>
                    </tr>
                </thead>
                <tbody class="text-[#5C727D]">
                    {sp_plans.map((plan, index) => (
                        <tr key={plan.id} className="hover:bg-gray-50">
                            <td className="border px-4 py-2">{index + 1}</td>
                            <td className="border px-4 py-2">{plan.product_name}</td>
                            <td className="border px-4 py-2">{plan.product_sale_point}</td>
                        </tr>
                    ))}
                    {/* <tr class="border-2">
                        <td class="border-2 bg-white p-3 text-md">Shaktaras Syrup</td>
                        <td class="border-2 bg-white p-3 text-md">9</td>
                        <td class="border-2 bg-white p-3 text-md">Swateeras Syrup</td>
                        <td class="border-2 bg-white p-3 text-md">7</td>
                        <td class="border-2 bg-white p-3 text-md">
                            Triphalagugulu Syrup
                        </td>
                        <td class="border-2 bg-white p-3 text-md">7</td>
                    </tr>
                    <tr class="border-2">
                        <td class="border-2 bg-gray-50 p-3 text-md">
                            Hemakshi Syrup
                        </td>
                        <td class="border-2 bg-gray-50 p-3 text-md">10</td>
                        <td class="border-2 bg-gray-50 p-3 text-md">
                            Healartho Syrup
                        </td>
                        <td class="border-2 bg-gray-50 p-3 text-md">10</td>
                        <td class="border-2 bg-gray-50 p-3 text-md">
                            Healartho Capsule
                        </td>
                        <td class="border-2 bg-gray-50 p-3 text-md">5</td>
                    </tr>
                    <tr class="border-2">
                        <td class="border-2 bg-white p-3 text-md">
                            Denta+ Toothpaste
                        </td>
                        <td class="border-2 bg-white p-3 text-md">2</td>
                        <td class="border-2 bg-white p-3 text-md">
                            Healartho Anti Pain Oil
                        </td>
                        <td class="border-2 bg-white p-3 text-md">4</td>
                        <td class="border-2 bg-white p-3 text-md">Denta Magic Jel</td>
                        <td class="border-2 bg-white p-3 text-md">1</td>
                    </tr>
                    <tr class="border-2">
                        <td class="border-2 bg-gray-50 p-3 text-md">
                            Keshav Hair Oil
                        </td>
                        <td class="border-2 bg-gray-50 p-3 text-md">4</td>
                        <td class="border-2 bg-gray-50 p-3 text-md">
                            Keshav herbal Shampoo
                        </td>
                        <td class="border-2 bg-gray-50 p-3 text-md">5</td>
                        <td class="border-2 bg-gray-50 p-3 text-md">Evo Facewash</td>
                        <td class="border-2 bg-gray-50 p-3 text-md">1</td>
                    </tr>
                    <tr class="border-2">
                        <td class="border-2 bg-white p-3 text-md">
                            Tensonil Tablets
                        </td>
                        <td class="border-2 bg-white p-3 text-md">6</td>
                        <td class="border-2 bg-white p-3 text-md">SSB Capsule</td>
                        <td class="border-2 bg-white p-3 text-md">15</td>
                        <td class="border-2 bg-white p-3 text-md">
                            Piles-Off Capsule
                        </td>
                        <td class="border-2 bg-white p-3 text-md">8</td>
                    </tr>
                    <tr class="border-2">
                        <td class="border-2 bg-gray-50 p-3 text-md">
                            Prostone Capsule
                        </td>
                        <td class="border-2 bg-gray-50 p-3 text-md">5</td>
                        <td class="border-2 bg-gray-50 p-3 text-md">
                            Gulnorm Capsule
                        </td>
                        <td class="border-2 bg-gray-50 p-3 text-md">9</td>
                        <td class="border-2 bg-gray-50 p-3 text-md">
                            Gulnorm Powder
                        </td>
                        <td class="border-2 bg-gray-50 p-3 text-md">1</td>
                    </tr>
                    <tr class="border-2">
                        <td class="border-2 bg-white p-3 text-md">
                            Chyawanprash Special
                        </td>
                        <td class="border-2 bg-white p-3 text-md">1</td>
                        <td class="border-2 bg-white p-3 text-md">Aloevera Jel</td>
                        <td class="border-2 bg-white p-3 text-md">1</td>
                        <td class="border-2 bg-white p-3 text-md">Dhoop batti</td>
                        <td class="border-2 bg-white p-3 text-md">0.5</td>
                    </tr> */}
                </tbody>
            </table>
        </div>
    );
};

export default ProductSalePointTable;
